<template>
<ion-page id="lichess-arena-page">
  <ion-content>
    <div :style="styleExplain" :class="{ 
                    'text-light' : isDark,
                    'text-dark' : !isDark, 
                    'done-button-color' : true }" v-html="explainMessage">
    </div>
    <div  :class="{ 'text-light' : !isDark,'text-dark' : isDark }" 
                            :style="styleArena">
   
      <div >
        <div v-for="item in startedTournaments" v-bind:key="item.index">
          <div :id="item.elementId" :style="oneTournamentStyleHeight" @click="onClick('started',item.index)" :class="{
                  'reptree-selected-text-dark' : (item.selected) && isDark,
                  'reptree-move-text-dark'     : (!(item.selectedd)) && isDark,
                  'reptree-selected-text-light' : (item.selected) && !isDark,
                  'reptree-move-text-light'     : (!(item.selected)) && !isDark
                }">
            {{ item.name }}
            <br>
            {{  item.duration }} {{ item.rated }}
            <br>
            {{ t("Time") }}:{{ item.time}} {{ t("Players") }}: {{ item.players }}
          </div>
          <hr>
        </div>
        <hr>
        <hr>
        <div v-for="item in createdTournaments" v-bind:key="item.index">
          <div :id="item.elementId" :style="oneTournamentStyleHeight" @click="onClick('created',item.index)" :class="{
                  'reptree-selected-text-dark' : (item.selected) && isDark,
                  'reptree-move-text-dark'     : (!(item.selectedd)) && isDark,
                  'reptree-selected-text-light' : (item.selected) && !isDark,
                  'reptree-move-text-light'     : (!(item.selected)) && !isDark
                }">
            {{ item.name }}
            <br>
            {{  item.duration }} {{ item.rated }}
            <br>
            {{ t("Time") }}:{{ item.time}} {{ t("Players") }}: {{ item.players }}
          </div>       
          <hr>
        </div>
      </div>
    </div>
  </ion-content>
  <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
</ion-page>

</template>

<script setup>

  import { IonIcon,IonPage, IonContent , modalController } from '@ionic/vue';

  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { ref, watch } from 'vue'
  import Toolbar from '@/components/Toolbar.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData , getLichessData, generateErrorAlertText } from '@/composables/getData.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  const emit = defineEmits(['next-item-click'])

  //console.log("********* In ARENA")
  const connectionStore = useConnectionStore()
  const lichessAccessToken = connectionStore.getLichessAccessToken

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)
  var currentTournamentIndexInView = 0
  var tournamentListHeight = 0
  var oneTournamentHeight = 75
  var tournamentsPerScroll = 1
  var oneTournamentStyleHeight = "height : 60px;"

  const HEIGHT_OF_EXPLAIN_AREA = 75
  const TOOLBAR_JOIN = 0
  const TOOLBAR_LEAVE = 1
  const TOOLBAR_SCROLL_UP = 2
  const TOOLBAR_SCROLL_DOWN = 3
  const TOOLBAR_DONE = 4

  const toolbarElements = ref([
    { index : TOOLBAR_JOIN, label : "Join" ,disabled : true},
    { index : TOOLBAR_LEAVE, label : "Leave" ,disabled : true},
  ])

   if (showBigButtons.value) {
    toolbarElements.value.push({ index : TOOLBAR_SCROLL_UP, label : t("Up") ,disabled : false})
    toolbarElements.value.push({ index : TOOLBAR_SCROLL_DOWN, label : t("Down") ,disabled : false})
  }

  if (whichMenu == "buttons")
    toolbarElements.value.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})

  const toolbarTrigger = ref(0)

  const startedTournaments = ref([])
  const createdTournaments = ref([])

  const explainMessage = ref("")

  var selectedTournament = null
  var selectedAction = ""

  const styleExplain = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleArena = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  doStartupCheck(false,afterStartupCallbackRoutine)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    getArenaTournaments()
    menuTrigger.value++
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
    menuTrigger.value++
  })

  function updateStyleObjects(boundaries) {

    styleExplain.value.height = boundaries['explain'].height + "px"
    styleExplain.value.width = boundaries['explain'].width + "px"
    styleExplain.value.top = boundaries['explain'].top + "px"
    styleExplain.value.left = boundaries['explain'].left + "px"

    styleArena.value.height = boundaries['arena'].height + "px"
    styleArena.value.width = boundaries['arena'].width + "px"
    styleArena.value.top = boundaries['arena'].top + "px"
    styleArena.value.left = boundaries['arena'].left + "px"

    tournamentListHeight = boundaries['arena'].height
     oneTournamentHeight = 75
    if (showBigButtons.value)
      oneTournamentHeight = Math.floor(oneTournamentHeight * connectionStore.getToolbarScalePercentage / 100.0)
    oneTournamentStyleHeight = "height : " + oneTournamentHeight + "px"
    tournamentsPerScroll = (oneTournamentHeight >= oneTournamentStyleHeight) ? 1 : Math.floor(tournamentListHeight / oneTournamentHeight)
   
  }

  function updateWidthHeights() {
    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    const explainPositionTop = 0
    const explainPositionLeft = availableSpace.leftRightIndent
    const explainHeight = HEIGHT_OF_EXPLAIN_AREA
    const explainWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const arenaPositionTop = HEIGHT_OF_EXPLAIN_AREA
    const arenaPositionLeft = availableSpace.leftRightIndent
    const arenaHeight = availableSpace.height - arenaPositionTop
    const arenaWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { 
      explain : {
        width : explainWidth,
        height : explainHeight,
        left : explainPositionLeft + availableSpace.leftIndent,
        top : explainPositionTop+ availableSpace.topIndent
      },
      arena : {
        width : arenaWidth,
        height : arenaHeight,
        left : arenaPositionLeft + availableSpace.leftIndent,
        top : arenaPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    const explainPositionTop = 0
    const explainPositionLeft = availableSpace.leftRightIndent
    const explainHeight = HEIGHT_OF_EXPLAIN_AREA
    const explainWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const arenaPositionTop = HEIGHT_OF_EXPLAIN_AREA
    const arenaPositionLeft = availableSpace.leftRightIndent
    const arenaHeight = availableSpace.height - arenaPositionTop
    const arenaWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = {
      explain : {
        width : explainWidth,
        height : explainHeight,
        left : explainPositionLeft + availableSpace.leftIndent,
        top : explainPositionTop+ availableSpace.topIndent
      },
      arena : {
        width : arenaWidth,
        height : arenaHeight,
        left : arenaPositionLeft + availableSpace.leftIndent,
        top : arenaPositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  function scrollList(direction) {
    const totalTournaments = startedTournaments.value.length + createdTournaments.value.length
    if (totalTournaments <= 1)
      return
    if (direction == "up") 
      currentTournamentIndexInView -= tournamentsPerScroll
    else
      currentTournamentIndexInView += tournamentsPerScroll
    if (currentTournamentIndexInView < 0)
      currentTournamentIndexInView = 0
    else
    if (currentTournamentIndexInView >= totalTournaments)
      currentTournamentIndexInView = totalTournaments - 1
    const element = document.getElementById(String(currentTournamentIndexInView));
    //console.log("scroll", currentTournamentIndexInView,element)
    if (element != null)
      element.scrollIntoView({ behavior: "smooth" })
  }

  function toolbarClick(arrayIndex) {
    switch (arrayIndex) {
      case TOOLBAR_DONE : 
        emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
        break
      case TOOLBAR_SCROLL_UP :
        scrollList("up")
        break
      case TOOLBAR_SCROLL_DOWN :
        scrollList("down")
        break
      case TOOLBAR_JOIN :
        if (selectedTournament == null)
          break
        selectedAction = "join"
        joinLeaveTournament("join",selectedTournament)
        break
      case TOOLBAR_LEAVE :
        if (selectedTournament == null)
          break
        selectedAction = "leave"
        joinLeaveTournament("withdraw",selectedTournament)
        break
    }
  }

  function onClick(which,index) {

    // remove any selected
    for (var i=0; i < startedTournaments.value.length; i++)
      startedTournaments.value[i].selected = false
    for (var i=0; i < createdTournaments.value.length; i++)
      createdTournaments.value[i].selected = false
      
    if (which == "started") {
      startedTournaments.value[index].selected = true
      selectedTournament = startedTournaments.value[index]
    }
    else {
      createdTournaments.value[index].selected = true
      selectedTournament = createdTournaments.value[index]
    }
  
    toolbarElements.value[TOOLBAR_JOIN].disabled = false
    toolbarElements.value[TOOLBAR_LEAVE].disabled = false
    toolbarTrigger.value++
  }

  function processJsonArenaTournament(tournament, timenow, loop) {
        
    const id = tournament["id"]
    const variantElement = tournament["variant"]
    const perfElement = tournament["perf"]
    const clockElement = tournament["clock"]

    // id, rated, number of players and title
    const fullName = tournament["fullName"]
    const playerCount = tournament["nbPlayers"]
    const ratedNumber = tournament["rated"]
    const startsAt = tournament["startsAt"]
    const finishesAt = tournament["finishesAt"]

    if (id == undefined || variantElement == undefined || perfElement == undefined ||
        clockElement == undefined || fullName == undefined || playerCount == undefined ||
        ratedNumber == undefined || startsAt == undefined || finishesAt == undefined)
        return
    
    // variant key=standard
    const variantKey = variantElement["key"]
    if (variantKey == undefined || variantKey != "standard")
        return
    
    // perf key=rapid
    const perfKey = perfElement["key"]
    if (perfKey == undefined || perfKey != "rapid")
        return

    // time & increment
    const clockLimit = clockElement["limit"]
    const clockIncrement = clockElement["increment"]
    if (clockLimit == undefined || clockIncrement == undefined)
        return
  
    const clockLimitMinutes = Math.floor(clockLimit / 60)
    const startsAtSeconds = Math.floor(startsAt / 1000)
    const finishAtSeconds = Math.floor(finishesAt / 1000)

    var timeDurationString = ""
    var startTimeString = ""

    // tournament is on now
    if (startsAtSeconds <= timenow) {
        const timeLeftInMinutes = Math.floor((finishAtSeconds - timenow) / 60)
        timeDurationString = t("Now for") + " " + timeLeftInMinutes + " " + t("minutes")
        startTimeString = t("Now")
    } 
    else {
        const timeLeftInMinutes = Math.floor((finishAtSeconds - startsAtSeconds) / 60)
        
        const secondsUntilStart = Math.floor(startsAtSeconds - timenow)
        const minutesUntilStart = Math.floor(secondsUntilStart / 60)
        const startMinutes = Math.floor(minutesUntilStart % 60)
        const startHours = Math.floor(minutesUntilStart / 60)
        
        startTimeString = (startMinutes < 10) ? startHours + ":0" + startMinutes : 
                                                    startHours + ":" +startMinutes
        timeDurationString = t("In") + " " + startTimeString + " " + t("for") + " " + timeLeftInMinutes + " " + t("mins")
    }

    const ratedString = (ratedNumber == 1) ? t("Rated") : t("Casual")
    const clockTimeString = clockLimitMinutes + "+" + clockIncrement

    const index = (loop == 0) ? startedTournaments.value.length : createdTournaments.value.length
    const oneTournament = { index : index,
            id : id,
            hasStarted : (loop == 0),
            name : fullName,
            duration : timeDurationString,
            startTime : startTimeString,
            rated : ratedString,
            time : clockTimeString,
            players : playerCount,
            selected : false
          }

    //console.log("ONE ",oneTournament)
    if (loop == 0)
      startedTournaments.value.push(oneTournament)
    else
      createdTournaments.value.push(oneTournament)
  }

  function processJsonResponse(json) {
    //console.log(" arena tournament callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const timenow = Math.floor(Date.now() / 1000)
    for (var loop = 0; loop < 2; loop++) {
      const loop_string = (loop == 0) ? "started" : "created";

      if (json.hasOwnProperty(loop_string) == false)
        continue
      const tournamentArray = json[loop_string]
      for (var i=0; i < tournamentArray.length; i++) {
        const t = tournamentArray[i]
        //console.log("tournament",loop,i,t)
        processJsonArenaTournament(t, timenow, loop)
      }
    }

    // two lists, need a html "id" that spans both
    var elementId = 0
    for (var i=0; i < startedTournaments.value.length; i++)
      startedTournaments.value[i].elementId = String(elementId++)
    for (var i=0; i < createdTournaments.value.length; i++)
      createdTournaments.value[i].elementId = String(elementId++)
  }

  function getArenaTournaments() {
    const urlStr = "https://lichess.org/api/tournament"
    getLichessData(urlStr, lichessAccessToken,null, processJsonResponse) 
  }

  function processJoinLeaveJsonResponse(json) {
    //console.log(" arena tournament join leave callback",json)

    // joining tournament. They might not qualify (not enough games, rating too high, ...)
    // also, tournament might have already started
           
    //console.log("tournament",selectedTournament)
    const errorString = json.hasOwnProperty('error') ? json["error"].message : ""
    const fullName = selectedTournament.name
    const startTimeString = selectedTournament.startTime
    var title = ""
    var message = ""
        
    const isJoin = (selectedAction == "join")
    if (isJoin) {
      if (errorString != "") {

        message = t("Attempt to join") + "<br>" + fullName + "<br>" 
        if (errorString.indexOf("status code 400"))
          message += t("Failed. You're probably not eligible")
        else
          message += t("Returned Error") + " -><br>" + errorString
      }
      else
      if (selectedTournament.hasStarted) {
        message = fullName + "<br>" + t("Has already started.") + "<br>" +
                        t("Go to the 'Open Games List' on the 'Lichess Menu' now to see your pairing.") + "<br>" +
                        t("Pairings sometimes take a little while to show up so use the 'Refresh' button on that screen every so often")
      }
      else {
        message = fullName + "<br>" + t("Will start in") + " -> " + startTimeString + "<br>" +
                                t("At that time, go to the 'Open Games List' on the 'Lichess Menu' to get your pairing.") + "<br>" +
                                t("Pairings sometimes take a little while to show up so use the 'Refresh' button on that screen every so often")
      }
    }
    else {
      message = t("You have now left") + "<br>" + fullName + "<br>" +
                    t("Please note it's possible you had not joined that tournament. No indication is available to this app")
    }
    
    explainMessage.value = message
  }

  function joinLeaveTournament(operation,tournament) {

    const id = tournament.id
    var formData = { }
    const urlStr = "https://lichess.org/api/tournament/" + id + "/" + operation

    getLichessData(urlStr, lichessAccessToken,formData, processJoinLeaveJsonResponse) 
  }

</script>

<style scoped>

.reptree-move-text-light {
  color : #000;
}
.reptree-move-text-dark {
  color : #fff;
}

.reptree-move-text-light:hover {
    background: #4c6ca0;
}

.reptree-move-text-dark:hover {
    background: #4c6ca0;
}

.reptree-selected-text-light {
  color : blue;
  background : yellow;
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

.repselector-center-text {
    text-align: center;
    margin-bottom : 10px;
    font-style :italic;
  }

  .repselector-center-text:hover {
    background: #4c6ca0;
  }

  .repselector-heading-color {
    background: #4c6ca0;
    color : white;
  }

</style>
